import React, { useState } from "react";
import { api } from "../../lib/api";
import { act } from "../../lib/useFetch";
import { ORDER_STATUS_LABELS, PRIORITIES } from "../../lib/constants";
import { rub, fmtDateTime, toInputValue, fromInputValue } from "../../lib/format";
import AdminDialog, { Field, DialogButtons } from "./AdminDialog";

export function BriefDialog({ order, onClose }) {
  const rows = [["Клиент", `${order.user_name || "—"} · ${order.user_email || ""}`], ["Услуга", order.service_title], ["Цена", rub(order.price)],
    ["Статус", ORDER_STATUS_LABELS[order.status]], ["Язык клиента", order.language], ["Приоритет", PRIORITIES[order.priority] || "—"],
    ["Дедлайн", fmtDateTime(order.deadline)], ["Источник", order.source || "—"]];
  return (
    <AdminDialog wide title="📋 Бриф заказа" onClose={onClose} testid="order-brief-dialog">
      <div className="grid sm:grid-cols-2 gap-2 text-sm">
        {rows.map(([l, v]) => <div key={l}><span className="text-gray-500">{l}: </span>{v}</div>)}
      </div>
      <div className="glass-cyan rounded-xl p-4 mt-4 text-sm whitespace-pre-line" data-testid="order-brief-text">
        {order.brief || "Бриф пока пуст — заполните его через ✏️."}
      </div>
      {order.reject_reason && <p className="text-sm text-red-400 mt-3">Причина отклонения: {order.reject_reason}</p>}
    </AdminDialog>
  );
}

export function RejectDialog({ order, onClose, onSaved }) {
  const [reason, setReason] = useState("");
  const save = async (e) => {
    e.preventDefault();
    if (await act(api.post(`/admin/orders/${order.id}/reject`, { reason }), "Заказ отклонён")) onSaved();
  };
  return (
    <AdminDialog title="❌ Отклонить заказ" description={order.service_title} onClose={onClose} testid="order-reject-dialog">
      <form onSubmit={save} className="space-y-3">
        <Field label="Причина"><textarea rows={3} required value={reason} onChange={(e) => setReason(e.target.value)} data-testid="order-reject-reason" /></Field>
        <DialogButtons onClose={onClose} testid="order-reject" saveLabel="Отклонить" />
      </form>
    </AdminDialog>
  );
}

export function DeadlineDialog({ order, onClose, onSaved }) {
  const [value, setValue] = useState(toInputValue(order.deadline));
  const save = async (e) => {
    e.preventDefault();
    if (await act(api.patch(`/admin/orders/${order.id}/deadline`, { deadline: fromInputValue(value) }), "Дедлайн обновлён")) onSaved();
  };
  return (
    <AdminDialog title="📅 Изменить дедлайн" description={order.service_title} onClose={onClose} testid="order-deadline-dialog">
      <form onSubmit={save} className="space-y-3">
        <Field label="Дедлайн"><input type="datetime-local" value={value} onChange={(e) => setValue(e.target.value)} data-testid="order-deadline-value" /></Field>
        <button type="button" onClick={() => setValue("")} className="text-xs text-gray-400 underline" data-testid="order-deadline-clear">Убрать дедлайн</button>
        <DialogButtons onClose={onClose} testid="order-deadline" />
      </form>
    </AdminDialog>
  );
}
